"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTradeInVehicleInputToFaunaInput = void 0;
const utils_1 = require("../../utils");
const mapTradeInVehicleInputToFaunaInput = (input) => {
    const { id } = input, data = __rest(input, ["id"]);
    return utils_1.FaunaMapper.mapFaunaInput(Object.assign(Object.assign({}, data), { capital: data.price - data.loan }));
};
exports.mapTradeInVehicleInputToFaunaInput = mapTradeInVehicleInputToFaunaInput;
//# sourceMappingURL=tradeIn.js.map